
















import {Component, Vue, Prop} from 'vue-property-decorator';

@Component
export default class AnimalSubscriptionsTable extends Vue {
  @Prop({type: Array, default: null}) private subscriptions!: any;

  private headers: any = [
    {text: 'Name', value: 'user.given_name'},
    {text: 'Email', value: 'user.email'},
    {text: 'Entry Date', value: 'entry_date'},
    {text: 'Amount', value: 'amount'},
    {text: 'Var Sym', value: 'var_sym'},
  ];
}
